__turbopack_context__.v({
  "close_icon": "_2rt2Dq_close_icon",
  "profile": "_2rt2Dq_profile",
  "sign_in": "_2rt2Dq_sign_in",
  "sign_in_menu": "_2rt2Dq_sign_in_menu",
  "sign_in_or_profile": "_2rt2Dq_sign_in_or_profile",
  "sign_in_or_profile_svp": "_2rt2Dq_sign_in_or_profile_svp",
  "user_button": "_2rt2Dq_user_button",
  "user_image_inital": "_2rt2Dq_user_image_inital",
  "user_menu": "_2rt2Dq_user_menu",
  "user_menu_is_open": "_2rt2Dq_user_menu_is_open",
});
